module.exports = __webpack_public_path__ + "img/xls.724829f9.png";